import React from 'react';
import { Input, Space, Button, Radio } from 'antd';
import { SearchOutlined, ExclamationCircleFilled, CheckCircleFilled } from '@ant-design/icons';
import { DataIndex } from './LicenseOverviewTable';

interface SearchFilterProps {
  selectedKeys: string[];
  setSelectedKeys: (keys: string[]) => void;
  confirm: () => void;
  clearFilters: () => void;
  handleSearch: (keys: any, confirm: () => void, dataIndex: DataIndex) => void;
  handleReset: (clear: () => void, dataIndex: DataIndex, confirm: () => void) => void;
  dataIndex: DataIndex;
}

export const SearchFilter: React.FC<SearchFilterProps> = ({
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
  handleSearch,
  handleReset,
  dataIndex,
}) => (
  <>
    <Input
      placeholder={`Search ${dataIndex
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())}`}
      value={selectedKeys[0]}
      onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
      onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
      style={{ width: 188, marginBottom: 8, display: "block" }}
    />
    <Space>
      <Button
        type="primary"
        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 100 }}
      >
        Search
      </Button>
      <Button
        onClick={() => clearFilters && handleReset(clearFilters, dataIndex, confirm)}
        size="small"
        style={{ width: 90 }}
      >
        Reset
      </Button>
    </Space>
  </>
);

export const WarningFilter: React.FC<SearchFilterProps> = ({
    selectedKeys,
    setSelectedKeys,
    confirm,
    clearFilters,
    handleSearch,
    handleReset,
    dataIndex,
  }) => (
    <>
      <Radio.Group
        options={[
          {
            label: (
              <>
                <ExclamationCircleFilled style={{ color: "red" }} /> Expiring Soon
              </>
            ),
            value: "warning",
          },
          {
            label: (
              <>
                <ExclamationCircleFilled style={{ color: "orange" }} /> About to Expire
              </>
            ),
            value: "close",
          },
          {
            label: (
              <>
                <CheckCircleFilled style={{ color: "#4BB543" }} /> Active
              </>
            ),
            value: "safe",
          },
        ]}
        value={selectedKeys[0]}
        onChange={(e) => {
          setSelectedKeys([e.target.value]);
          handleSearch([e.target.value], confirm, dataIndex);
        }}
        optionType="button"
        buttonStyle="solid"
        style={{ display: "flex", flexDirection: "column", gap: "8px" }}
      />
      <Space style={{ marginTop: 8, justifyContent: "center", width: "100%" }}>
        <Button
          type="primary"
          onClick={() => clearFilters && handleReset(clearFilters, dataIndex, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </Space>
    </>
  );
